export default __webpack_public_path__ + "static/media/Turmeric.7d07fd2d.jpg";